export enum OrigamiModuleType {
  any = 0,
  ssu = 1,
  etmf = 2,
  collaboration = 3,
  programsmanagement = 4,
}
